if(typeof _GIRL_CONF['sanshi']['game_memory']=='undefined'){_GIRL_CONF['sanshi']['game_memory']={};};
_GIRL_CONF['sanshi']['game_memory']['face']={left:486,top:162,width:127,height:126};
_GIRL_CONF['sanshi']['game_memory']['hair1']={left:414,top:10,width:297,height:281};
_GIRL_CONF['sanshi']['game_memory']['hair2']={left:602,top:126,width:173,height:383};
_GIRL_CONF['sanshi']['game_memory']['hand1']={left:466,top:525,width:231,height:59};
_GIRL_CONF['sanshi']['game_memory']['hand2']={left:460,top:289,width:325,height:318};
_GIRL_CONF['sanshi']['game_memory']['item1']={left:186,top:247,width:228,height:438};
_GIRL_CONF['sanshi']['game_memory']['item2']={left:958,top:362,width:146,height:293};
_GIRL_CONF['sanshi']['game_memory']['item3']={left:347,top:594,width:594,height:138};
_GIRL_CONF['sanshi']['game_memory']['tits']={left:513,top:323,width:153,height:149};
